// @mui material components
import Grid from '@mui/material/Grid';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';

// Soft UI Dashboard PRO React example components
import BaseLayout from 'layouts/pages/account/components/BaseLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import TimelineList from 'prefabsComponents/Timeline/TimelineList';
import TimelineItem from 'prefabsComponents/Timeline/TimelineItem';
import SoftTypography from 'components/SoftTypography';

// @mui icons
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

// Soft UI Dashboard PRO React example components
import OrderCard from 'components/OrderCard';

// Data
import timelineData from 'layouts/pages/orders/order-track/data/timelineData';

function Timeline() {
    const renderTimelineItems = timelineData.map(
        ({ color, icon, title, dateTime, description, badges, lastItem }) => (
            <TimelineItem
                key={title + color}
                color={color}
                icon={icon}
                title={title}
                dateTime={dateTime}
                description={description}
                badges={badges}
                lastItem={lastItem}
            />
        )
    );

    return (
        <BaseLayout>
            <SoftBox my={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <TimelineList title="Seguimientos" dark>
                            {renderTimelineItems}
                        </TimelineList>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Grid item xs={12} md={6} xl={6}>
                            <OrderCard
                                numero="#PO50987-0"
                                info={{
                                    cliente: 'Methanex',
                                    'Fecha de Embarque': '12-08-2024',
                                    'Fecha de Arribo': '02-09-2024',
                                    'Fecha Real de Arribo': '05-09-2024',
                                }}
                            />

                        </Grid>
                    </Grid>
                </Grid>
            </SoftBox>
        </BaseLayout>
    );
}

export default Timeline;
